import { InjectionToken } from '@angular/core';

export interface ApiConfig {
    rest: RestConfig;
    appVersion: string;
}

export interface RestConfig {
    API_URL: string;
    API_SUBSCRIPTION_KEY: string;
}
export const RestConfigService = new InjectionToken<RestConfig>('RestConfig');
export const AppVersionConfigService = new InjectionToken<string>('AppVersionConfig');